module.exports = __webpack_public_path__ + "img/immersive_cover_arts.6c1cc934.png";